module.exports = __webpack_public_path__ + "static/media/telegraph_logo.5fa3a4f0.svg";